import { AttendanceSearch, StaffUser } from 'components/Pages/Admin/CheckinPage/QrCodeScanner/types';
import * as Rx from 'rxjs';
import RxOp from 'rxjs-operators';

import apiService, { ApiService } from '../api';
import { AddSttaff, GetStaffByUserId, StaffListByEventId } from './types';

export class EventStaffService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public addEventStaff(data: AddSttaff): Rx.Observable<any> {
    return this.apiService.post('/event/create_staff', data);
  }

  public getStaffByUserId(): Rx.Observable<{ data: GetStaffByUserId }> {
    return this.apiService.get('/event/list_staff_by_user_id');
  }

  public staffListByEventId(eventId): Rx.Observable<{ data: StaffListByEventId }> {
    return this.apiService.get(`/event/list_staff/${eventId}`);
  }

  public getAccess(token: string): Rx.Observable<any> {
    return this.apiService
      .get('/event_services/staff-auth', { token }, { ignoreErrorHandler: true })
      .pipe(RxOp.map(response => response));
  }

  public deleteEventStaff(eventId, staffId): Rx.Observable<any> {
    return this.apiService.delete(`/event/delete_staff/${eventId}/${staffId}`);
  }

  public resendAccessLinkEventStaff(eventId, staffId): Rx.Observable<any> {
    return this.apiService.post(`/event/resend_access_link/${eventId}/${staffId}`, {});
  }

  public getStaffDetails(token: string): Rx.Observable<StaffUser> {
    const headers = { 'Staff-Token': token };
    return this.apiService
      .getWithHeader('/event/staff_details', null, headers)
      .pipe(RxOp.map(response => response.data));
  }

  public getCheckinHistoryStaff(token: string): Rx.Observable<any> {
    const headers = { 'Staff-Token': token };
    return this.apiService
      .getWithHeader('/presence/v2/checkin/history', null, headers)
      .pipe(RxOp.map(response => response.data));
  }

  public searchTicket(searchType: string, searchValue: string, token: string): Rx.Observable<AttendanceSearch[]> {
    const header = { 'Staff-Token': token };
    return this.apiService
      .getWithHeader('/presence/v2/attendances', { [searchType]: searchValue }, header, { ignoreErrorHandler: true })
      .pipe(RxOp.map(response => response.data));
  }
}

const eventStaffService = new EventStaffService(apiService);
export default eventStaffService;
